module.exports = __webpack_public_path__ + "img/brandme_influencer_software.641745c2.svg";